















import LoginRequired from './scripts';
export default LoginRequired;
